import { useFormContext } from 'react-hook-form'
import RadioInput from '@components/form/RadioInput'
import Error from '@components/form/validation/Error'

const ContextRadioInput = (props) => {
    const { register } = useFormContext()
    const { error, ...rest } = props
    return <>
        <RadioInput {...rest} register={register} />
        { error && <Error name={props.name} /> }
    </>
}

export default ContextRadioInput